/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import get from "lodash/get";

export const API_URL = process.env.REACT_APP_API_URL;

export const URLEncoded = {
  "Content-Type": "application/x-www-form-urlencoded",
};

export const Multipart = {
  "Content-Type": "multipart/form-data",
};

export const JSONBody = {
  "Content-Type": "application/json",
};

export const RequestType = {
  URLEncoded,
  Multipart,
  JSONBody,
};


export const Methods = {
  HEAD: "head",
  GET: "get",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete",
};

export const withToken = async (options, getState = () => { }) => {
  //console.log("Token: ", get(getState(), "auth.login.dataUser.tokenGenerated"));
  
  return {
    ...options,
    token: get(getState(), "auth.login.dataUser.tokenGenerated"),
  };
};

export const getOptions = ({
  data,
  method,
  token = null,
  headers: extraHeaders = {},
  params = {},
  companyid,
  userid,
}) => {
  const headers = {
    userid: userid,
    companyid: companyid,
    Accept: "application/json",
    ...JSONBody,
    ...extraHeaders,
    "Access-Control-Allow-Origin": "*", // CORS header
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS", // CORS header
    "Access-Control-Allow-Headers": "Origin, Content-Type, Accept, Authorization", // CORS header
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const options = {
    baseURL: API_URL,
    method,
    data,
    headers,
    params: { ...params },
  };

  return options;
};

export default (url, options) => axios({ url, ...getOptions(options) });
